import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TelaComCamposStruct } from '@shared/services/structs/financas/tela-com-campos.struct';
import { CampoObrigatorioStruct } from '@shared/services/structs/financas/campo-obrigatorio.struct';

/**
 * Seção de uma tela configurável nas Configurações de campos obrigatórios (Finanças e Cadastros).
 * Marca/desmarca `isObrigatorio` direto nos campos da `tela` recebida; quem carrega e salva é a
 * página hospedeira. O seletor aberto é controlado pela página (`seletorAberto`) para manter
 * apenas um seletor aberto entre as seções.
 */
@Component({
    selector: 'app-campos-obrigatorios-secao',
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule
    ],
    templateUrl: './campos-obrigatorios-secao.component.html',
    styleUrls: ['./campos-obrigatorios-secao.component.css']
})
export class CamposObrigatoriosSecaoComponent {
    @Input({ required: true }) tela!: TelaComCamposStruct;
    @Input() seletorAberto = false;
    @Output() seletorAbertoChange = new EventEmitter<boolean>();

    public readonly tooltipSemCamposDisponiveis = 'Todos os campos disponíveis desta tela já estão marcados como obrigatórios';

    getCamposObrigatorios(): CampoObrigatorioStruct[] {
        return this.tela.listaCampos.filter(c => c.isObrigatorio);
    }

    getCamposDisponiveis(): CampoObrigatorioStruct[] {
        return this.tela.listaCampos.filter(c => !c.isObrigatorio && !c.isFixo);
    }

    toggleSeletor(): void {
        this.seletorAbertoChange.emit(!this.seletorAberto);
    }

    fecharSeletor(): void {
        this.seletorAbertoChange.emit(false);
    }

    /** O seletor continua aberto para adicionar outros campos; fecha sozinho quando não sobra nenhum. */
    adicionarCampo(campo: CampoObrigatorioStruct): void {
        campo.isObrigatorio = true;
        if (this.getCamposDisponiveis().length === 0) {
            this.fecharSeletor();
        }
    }

    removerCampo(campo: CampoObrigatorioStruct): void {
        if (!campo.isFixo) {
            campo.isObrigatorio = false;
        }
    }
}
